/**
 * 正则验证
 * @param {Number,String} str 需要验证的内容如：手机号，邮箱等
 * @param {String} type 需要正则验证的类型
 * @return {Boolean} true: 正则通过，输入无误。false: 正则验证失败，输入有误
 * @author Czy 2018-10-25
 */
export default function(str, type) {
  switch (type) {
    case 'phone': //手机号码
      return /^1[0-9]{10}$/.test(str);
    case 'CT': //皮肤CT
      return /^(([0-9]{1}\d*)|(0{1}))(\.\d*)?$/.test(str);
    case 'tel': //座机
      return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
    case 'account': //账号 ，长度4～16之间，只能包含数字，字母和下划线
      return /^[a-zA-Z0-9_-]{4,16}$/.test(str);
    case 'pwd': //密码以字母开头，长度在6~16之间，只能包含字母、数字和下划线 值+1
      return /^[a-zA-Z]\w{5,15}$/.test(str);
    case 'postal': //邮政编码
      return /[1-9]\d{5}(?!\d)/.test(str);
    case 'QQ': //QQ号
      return /^[1-9][0-9]{4,9}$/.test(str);
    case 'email': //邮箱
      return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str);
    case 'money': //金额(小数点2位)
      return /^\d*(?:\.\d{0,2})?$/.test(str);
    // case 'URL': //网址
    //   return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(str);
    case 'IP': //IP
      return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(str);
    // case 'date': //日期时间
    //   return (
    //     /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) ||
    //     /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
    //   );
    // case 'number': //数字
    //   return /^[0-9]$/.test(str);
    case 'smsNumber': //短信验证码数字
      return /^[0-9]{6}$/.test(str);
    case 'english': //英文
      return /^[a-zA-Z]+$/.test(str);
    case 'chinese': //中文
      return /^[\u4E00-\u9FA5]+$/.test(str);
    case 'lower': //小写
      return /^[a-z]+$/.test(str);
    case 'upper': //大写
      return /^[A-Z]+$/.test(str);
    case 'HTML': //HTML标记
      return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str);
    case 'bankCard': //银行卡号
      //  return /^([1-9]{1})(\d{15}|\d{18})$/.test(str);
      return /^([1-9][0-9]{15,18})$/.test(str);
    default:
      return true;
  }
}